// DMG-style 4 shade palette (0 lightest)
export const PAL = ["#e0f8d0", "#88c070", "#346856", "#081820"];
